import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { LoadingModule } from '@loading-lib/loading.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { UpdateCardComponent } from '@platform-lib/updates/update-card/update-card.component'
import { UpdatesRoutingModule } from '@platform-lib/updates/updates-routing.module'
import { UpdatesComponent } from '@platform-lib/updates/updates.component'
import { PageModule } from '@shared-ui-lib/page/page.module'
import { SectionModule } from '@shared-ui-lib/section/section.module'
import { SystemResponseModule } from '@shared-ui-lib/system-response/system-response.module'

@NgModule({
    declarations: [UpdatesComponent, UpdateCardComponent],
    exports: [UpdateCardComponent],
    imports: [
        CommonModule,
        LoadingModule,
        MatButtonModule,
        MatDividerModule,
        PageModule,
        SectionModule,
        SystemResponseModule,
        TranslationModule.forRoot(),
        UpdatesRoutingModule,
    ],
})
export class UpdatesModule {}
